import { Injectable } from '@angular/core'

export interface RuntimeConfig {
  apiUrl?: string
  socketUrl?: string
  tenantId?: string
  serviceApiKey?: string
  features?: Record<string, boolean | string>
}

@Injectable({ providedIn: 'root' })
export class RuntimeConfigService {
  private config: RuntimeConfig = {}
  private resolveConfigApplied!: () => void

  /**
   * Resolves once runtime config has been loaded AND applied to the environment.
   * Used by the auth initializer to wait for the environment to be ready
   * before making API calls (APP_INITIALIZER runs all initializers concurrently).
   */
  readonly configApplied = new Promise<void>((resolve) => {
    this.resolveConfigApplied = resolve
  })

  async loadConfig(): Promise<RuntimeConfig> {
    try {
      const response = await fetch('/config.json')
      if (response.ok) {
        this.config = await response.json()
      }
    } catch (error) {
      console.error('[RuntimeConfig] Failed to load config.json:', error)
    }
    return this.config
  }

  /** Call after runtime config values have been applied to the environment */
  markConfigApplied(): void {
    this.resolveConfigApplied()
  }

  getConfig(): RuntimeConfig {
    return this.config
  }
}
